import React from 'react';
import { cn } from '../../lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helperText?: string;
  errorMessage?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, helperText, errorMessage, className, id, ...props }, ref) => {
    const hasError = !!errorMessage;

    return (
      <div className="w-full">
        {label && (
          <label 
            htmlFor={id} 
            className="block text-xs font-semibold text-gray-700 mb-1"
          >
            {label}
          </label>
        )}
        <input
          id={id}
          ref={ref}
          className={cn(
            'w-full px-3 py-2 text-sm border rounded-lg bg-white text-gray-900 transition-colors duration-150 placeholder:text-gray-400 focus:outline-none focus:ring-2 dark:bg-slate-900 dark:text-white',
            hasError 
              ? 'border-red-500 focus:border-red-500 focus:ring-red-100' 
              : 'border-gray-300 focus:border-blue-500 focus:ring-blue-100',
            className
          )}
          {...props}
        />
        {errorMessage ? (
          <p className="text-xs text-red-600 mt-1">{errorMessage}</p>
        ) : helperText ? (
          <p className="text-xs text-gray-500 mt-1">{helperText}</p>
        ) : null}
      </div>
    );
  }
);

Input.displayName = 'Input';
